import { combineReducers } from "@reduxjs/toolkit";
import patient from "./patientSlice";
const reducer = combineReducers({
  patient,
});

export default reducer;
